/* eslint-disable class-methods-use-this */
import CollectionApi from 'client/api/v2/CollectionApi';
import axios from 'axios';

class CommandsApi extends CollectionApi {
  constructor() {
    super('/api/commands', {
      skip: 0,
      limit: 50,
      sort: 'name', // Prepend with a '-' to reverse default sort direction
      search: {
        fields: ['name', 'command', 'commandType'],
        searchTerm: '',
      },
    });
    this.baseUrl = '/api/commands';
  }

  addFile(file) {
    return axios.post('/api/files', file);
  }

  cancelQueuedCommands(queueIds) {
    return axios.post('/api/cancelQueuedCommands', { queueIds });
  }

  checkQueuedCommands(queueIds) {
    return this.initialize()
      .then(() => axios.post('/api/checkQueuedCommands', { queueIds }))
      .then(resp => resp.data);
  }

  deleteFile(file) {
    return axios.delete(`/api/files/${file._id}`);
  }

  getFiles(commandId) {
    return axios.get(`/api/files/command/${commandId}`);
  }

  getMostRecentResult(commandId) {
    return this.initialize()
      .then(() => axios.get(`${this.baseUrl}/${commandId}/results`))
      .then(resp => resp.data[resp.data.length - 1]);
  }

  modifyFile(file) {
    return axios.put(`/api/files/${file._id}`, file);
  }

  runCommand(command) {
    return axios.post('/api/runCommand', command);
  }

  fetchCommandDetail(commandId) {
    return axios.get(`/api/commands/${commandId}`);
  }

  async search(payload) {
    await this.initialize();
    return axios.post('/api/search/commands', payload);
  }
}

export default new CommandsApi();
